import http from "../../../utils/fetch";

export default {

    baseurl:'/api/swyl/v1/agent/weekYearMonth',

    getWeekList(query){
        return http({
            url: this.baseurl+'/selectList',
            method: 'post',
            params: query

        });

    }
}